<template>
    <div>
        <v-card elevation="0">
            <v-card color="#80CBC4" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-form-select</v-icon>
                    &nbsp;Form Controls
                </v-card-title>
            </v-card>
            <v-card-text>
                <v-tabs v-model="tab" background-color="transparent" color="#80CBC4" grow>
                    <v-tab v-for="item in tabitems" :key="item">
                        {{ item }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item><br />
                        <FormControl v-if="tab == 0"/>
                    </v-tab-item>
                    <v-tab-item>
                        <PostingControl v-if="tab == 1"/>
                    </v-tab-item>
                    <v-tab-item>
                        <CUPERep v-if="tab == 2"/>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>
        <iframe name="hiddenFrame" hidden></iframe>
    </div>
</template>
<script>
import FormControl from "../../../components/Admin/Settings/FormControl.vue"
import PostingControl from "../../../components/Admin/Settings/PostingControl.vue"
import CUPERep from "../../../components/Admin/Settings/CUPERep.vue"
export default {
    components: {
        FormControl,
        PostingControl,
        CUPERep
    },
    data(){
        return {
            tab: 0,
            tabitems: ["Form/Posting Controls", "Session Code Dates", "CUPE Representative"],
        }
    }
}
</script>